import { Link } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import {
  ListItemButton as MuiListItemButton,
  Typography as MuiTypography,
  ListItemIcon as MuiListItemIcon,
  ListItemText,
  Tooltip,
} from '@mui/material';

const ListItemIcon = styled(MuiListItemIcon, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ wide }) => ({
  '& svg': {
    width: '0.835em',
    height: '0.835em',
  },
  ...(wide && { paddingLeft: '4px' }),
}));

const ListItemButton = styled(MuiListItemButton, {
  shouldForwardProp: (prop) => prop !== 'wide',
})(({ theme, wide }) => ({
  backgroundColor: 'inherit',
  borderRadius: '6px',
  padding: wide ? '8px 6px' : '8px 10px',
  '&.Mui-selected, &:hover': {
    backgroundColor: 'inherit',
    borderRadius: '6px',
    fontSize: '18px',
  },
  '&.Mui-selected': {
    backgroundColor: 'inherit',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}));

const Typography = styled(MuiTypography, {
  shouldForwardProp: (prop) => prop !== 'wide' && prop !== 'selected',
})(({ theme, wide, selected }) => ({
  fontSize: '14px',
  fontWeight: '400',
  color: selected ? theme.palette.primary.light : theme.palette.common.white,
  ...(wide ? {} : { paddingLeft: '9px', display: 'none' }),
}));

export const SubMenuItem = ({ item, sx, selected, wide }) => (
  <Tooltip
    title={!wide ? item.title : ''}
    placement="right"
    arrow
  >
    <ListItemButton
      component={Link}
      to={item.path}
      sx={sx}
      wide={wide}
      selected={selected}
      data-testid="submenu-list-item"
    >
      <ListItemIcon wide={wide}>{item.icon}</ListItemIcon>
      <ListItemText
        primary={
          <Typography
            variant="subtitle2"
            wide={wide}
            selected={selected}
            data-testid="submenu-list-item-title"
          >
            {item.title}
          </Typography>
        }
      />
    </ListItemButton>
  </Tooltip>
);
